module.exports = __webpack_public_path__ + "img/glasses-icon.352e5533.svg";